<template>
<div style="height: 100%; position: relative;">
    <div id="d003" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
    <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
		<span class="dot bcPrimary"></span> {{overview[0].NAME}}&nbsp;
		<span class="dot bcSecondary"></span> {{overview[1].NAME}}&nbsp;
		<span v-if="overview.length === 3"><span class="dot bcTertiary"></span> {{overview[2].NAME}}</span>
	</div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
	import Vue from 'vue';
    import { colors } from '@/config';

    export default {
        name: "D003",
        components: {},
        props: {
            overview: Array,
            balance: Array
        },

        computed: {
            longest() {
                let l = 0;
                let x = 0;
                for (let i = 0; i < this.balance.length; i++) {
                    if (this.balance[i].sheets.length > l) {
                        l = this.balance[i].sheets.length;
                        x = i;
                    }
                }
                return x;
            }
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'column',
                    renderTo: 'd003',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },
                
                title: {
                    text: ''
                },

                legend: {
                    enabled: false
                },

                colors: [colors.Primary, colors.Secondary, colors.Tertiary],

                xAxis: {
                    categories: this.balance[this.longest].sheets.map( (s, i) => i === 0 ? 'Senaste bokslutet' : '' ),
                    labels: { 
                        style: { fontSize: '1.2rem', } 
                    },
                    reversed: true,
                    reversedStacks: true,
                },

                yAxis: {
                    opposite: true,
                    allowDecimals: false,
                    title: {
                        text: ''
                    },
                    labels: {
                        formatter: function() { return Vue.options.filters.KR(this.value); },
                        style: { fontSize: '1.2rem', } 
                    },
                    tickPixelInterval: 150,
                },

                tooltip: {
                    formatter: function () {
                        return '<b>' + this.series.name + '<br>Balansomslutning: ' + Vue.options.filters.TKR(this.y);
                    },
                    style: { fontSize: '1.5rem', } 
                },

                plotOptions: {
                    column: {
						borderColor: '#5d5d5d'
                    }
                },

                series: this.overview.map( (o, i) => { return {
                    name: o.NAME,
                    data: this.balance[i].sheets.map( s => s.A+s.E+s.K ),
                }}),
            });
        },

    }
</script>

<style scoped>
    .dot {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
    }
    
    .center {
        font-size: 1.2rem;
    }
</style>
